export default {
  centrosCustos(state) {
    return state.centrosCustos;
  },
  solicitantes(state) {
    return state.solicitantes;
  },
  searchText(state) {
    return state.searchText;
  },
  empresa(state) {
    return state.empresa;
  },
  produto(state) {
    return state.produto;
  },
  projeto(state) {
    return state.projeto;
  },
  grupo(state) {
    return state.grupo;
  },
  hasCustomFilters(state) {
    return [
      state.empresa,
      state.solicitantes && state.solicitantes.length,
      state.produto && state.produto.length,
      state.centrosCustos && state.centrosCustos.length,
      state.projeto && state.projeto.length,
      state.grupo && state.grupo.length,
    ].some(v => !!v);
  },
  stringFilter(state) {
    const filters = ['situacao in ("RECEBIDA")'];
    if (state.searchText) {
      const searchText = state.searchText.toLowerCase();
      filters.push(`(produto.nome like '%${searchText}%' or especificacaoProduto like '%${searchText}%' or identificador like '%${searchText}%' or responsavel.name like '%${searchText}%')`);
    }
    if (state.centrosCustos && state.centrosCustos.length) {
      const centroCustosFilter = state.centrosCustos.map(centroCusto => `(centroCusto = ${centroCusto.id})`);
      filters.push(`(${centroCustosFilter.join(' or ')})`);
    }
    if (state.solicitantes && state.solicitantes.length) {
      const solicitantesFilter = state.solicitantes.map(solicitante => `responsavel = ${solicitante.id}`);
      filters.push(`(${solicitantesFilter.join(' or ')})`);
    }
    if (state.empresa && state.empresa.id) {
      filters.push(`(comprador.id = ${state.empresa.id})`);
    }
    if (state.produto && state.produto.length) {
      const produtosFilter = state.produto.map(produto => `(produto.id = ${produto.id})`);
      filters.push(`(${produtosFilter.join(' or ')})`);
    }
    if (state.projeto && state.projeto.length) {
      const projetoFilter = state.projeto.map(projeto => `(projeto = ${projeto.id})`);
      filters.push(`(${projetoFilter.join(' or ')})`);
    }
    if (state.grupo && state.grupo.length) {
      const grupoFilter = state.grupo.map(grupo => `(produto.categoria.id = ${grupo.id})`);
      filters.push(`(${grupoFilter.join(' or ')})`);
    }
    return filters.join(' and ');
  },
};
